import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';
@Service()
export default class DashboardService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async Get(model: any): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/get-sender-requests';
            const result = await this.axiosService.axiosInstance.post(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async checkRenewSender(ids: string[]): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/check-sender-renewal';
            const model = {
                ids: ids,
            };
            const result = await this.axiosService.axiosInstance.post(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async approve(ids: string[], comment: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/approve';
            const model = {
                comment: comment,
                ids: ids,
            };
            const result = await this.axiosService.axiosInstance.put(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async finalApprove(ids: string[], comment: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/final-approve';
            const model = {
                comment: comment,
                ids: ids,
            };
            const result = await this.axiosService.axiosInstance.put(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async getRequestsOptions(): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/get-requests-options';
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async getReportOptions(): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/get-report-options';
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async isProviderLocked(): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/providers/is-provider-locked';
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async isProviderExpired(): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/providers/is-provider-expired';
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async delete(id: string, comment: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests?id=' + id
                + '&comment=' + comment;
            const result = await this.axiosService.axiosInstance.delete(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async deactivate(model: string[]): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/senders/deactivate';
            const result = await this.axiosService.axiosInstance.put(url, model);
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
  public async FavorClient(crNumber: string, unifiedNumber: string,customerType: number): Promise<any> {
    this.loaderService.ShowLoader();
    try {        
        const url = window.$config.HostName + 'api/senders/favor-client';
        const model = {
            crNumber: crNumber,
            enterpriseUnifiedNumber: unifiedNumber,
            customerType: customerType

        };
        const result = await this.axiosService.axiosInstance.put(url, model);
        return result.data;
    } catch (exception) {
        this.loaderService.HideLoader();
        return false;
    }
}

public async UnfavorClient(crNumber: string, unifiedNumber: string,customerType: number): Promise<any> {
    this.loaderService.ShowLoader();
    try {                

        const url = window.$config.HostName + 'api/senders/unfavor-client';
        const model = {
            crNumber: crNumber,
            enterpriseUnifiedNumber: unifiedNumber,
            customerType: customerType
        };
        const result = await this.axiosService.axiosInstance.put(url, model);
        return result.data;
    } catch (exception) {
        this.loaderService.HideLoader();
        return false;
    }
}

    public async resend(ids: string[], comment: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/resend';
            const model = {
                comment: comment,
                ids: ids,
            };
            const result = await this.axiosService.axiosInstance.put(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async reject(ids: string[], reason: string | null): Promise<any> {
        this.loaderService.ShowLoader();
        const request = {
            rejectionReason: reason,
            senderIds: ids,
        };
        try {
            const url = window.$config.HostName + 'api/sender-requests/reject';
            const result = await this.axiosService.axiosInstance.put(url, request);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async GetDashboardBoxes(): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/dashboardboxes';
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data.result;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async GetById(id: string): Promise<any> {
        try {
            const url = window.$config.HostName + 'api/sender-requests/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async sendrApproveEmail(ids: string[]): Promise<any> {
        // this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/send-approve-email';
            const result = await this.axiosService.axiosInstance.put(url, ids);
            // this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            // this.loaderService.HideLoader();
            return false;
        }
    }
    public async deleteRequestEmail(ids: string[]): Promise<any> {
        this.loaderService.ShowLoader();
        try {

            const url = window.$config.HostName + 'api/sender-requests/delete-request-email';
            const result = await this.axiosService.axiosInstance.put(url, ids);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async rejectRequestEmail(ids: string[]): Promise<any> {
        try {
            const url = window.$config.HostName + 'api/sender-requests/reject-request-email';
            const result = await this.axiosService.axiosInstance.put(url, ids);
            return result.data;
        } catch (exception) {
            return false;
        }
    }
    public async resendRequestEmail(ids: string[]): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/resend-request-email';
            const result = await this.axiosService.axiosInstance.put(url, ids);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async getSenderNameRejectReasons(requestType: number): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/RejectionReason/get-by-request-type?requestType=' + requestType;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async getSenderStatus(senderName: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/senders/get-sender-status';
            const result = await this.axiosService.axiosInstance.get(url, {
                params: { senderName }
            });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
}
